<template>
  <div class="ori-side-banner">
    <!-- app下载 -->
    <!--<div class="content-box">
      <div class="content" style="padding: 0; margin: 10px 0">
        <p class="title">
          <i class="iconfont iconapp primary mar10"></i>APP下载
        </p>
        <ul class="ew-cell mat10">
          <li class="ew">
            <div class="itemDiv">
              <div id="android" ref="android"></div>
              <p><i class="iconfont iconAndroid"></i> 安卓下载</p>
            </div>
            <div class="itemDiv">
              <div id="ios" ref="ios"></div>
              <p><i class="iconfont iconios"></i> ios下载</p>
            </div>
          </li>
        </ul>
      </div>
    </div>-->

    <div class="content-box">
      <!-- 公告通知 -->
      <div class="content">
        <p class="title mab20"><i class="icon icon1"></i>通知公告</p>
        <ul class="article-list">
          <li
            v-for="(item, index) in platformNotices"
            :key="item.id"
            class="link"
            @click="
              $router.push({
                name: 'studentNotices',
                query: {
                  uuid: item.id,
                },
              })
            "
          >
            <el-badge v-if="index < 2" style="max-width: 98%" value="new"
              ><span class="notice-tit">{{ item.title }}</span></el-badge
            >
            <span v-else class="notice-tit">{{ item.title }}</span>
          </li>
        </ul>

        <ComponentEmpty
          v-if="platformNotices.length == 0"
          style="padding: 0"
          imgClass="empty-img-size100"
          title="暂无公告通知"
          tips=""
        />
      </div>

      <!-- 客服中心 -->
      <!-- <div class="content">
        <p class="title">客服中心</p>
        <div class="phone-box">
          <span class="phone" style="display: block;"> <i class="icon"></i>023-62652911 </span>
          <span class="phone" style="display: block;"> <i class="icon"></i>023-62652917</span>
        </div>
        <a
          href="http://wpa.qq.com/msgrd?v=3&amp;uin=990352083&amp;site=qq&amp;menu=yes"
          target="_blank"
          rel="nofollow"
        >
          <el-button class="answer-btn" type="primary" plain
            >有问题？咨询技术部</el-button
          >
        </a>
      </div> -->

      <!-- 最新课程 -->
      <!-- <div class="content" v-if="role == 'student'">
        <p class="title"><i class="icon icon3"></i>最新课程</p>
        <div class="article-list">
          <p
            v-for="(item, index) in recentCourses"
            :key="index"
            class="link"
            @click="
              $router.push({
                name: 'subject',
                query: {
                  id: item.course_id,
                },
              })
            "
          >
            <span class="tit">{{ item.title }}</span>
            <span class="date">{{ item.created_at.substring(0, 10) }}</span>
          </p>

          <ComponentEmpty
            v-if="recentCourses.length == 0"
            style="padding: 0"
            imgClass="empty-img-size100"
            title="暂无最新课程"
            tips=""
          />
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import { getNewNotice, getNewCourse } from "@/api/basic";
import { mapState } from "vuex";
import { getStore } from "@/utils/localStorage";

export default {
  name: "SideBanner",
  data() {
    return {
      platformNotices: [],
      recentCourses: [],
      role: JSON.parse(getStore("userInfo")).user_type,
      appType: "android",
      androidCode: null,
      iosCode: null,
    };
  },
  computed: {
    ...mapState("common", {
      studentMajor: (state) => state.studentMajor,
    }),
  },
  watch: {
    studentMajor(val) {
      if (val) {
        this.getNotices();
        if (this.role == "student") {
          this.getRecentSpecialty();
        }
      }
    },
  },
  created() {
    if (this.studentMajor) {
      this.getNotices();
      if (this.role == "student") {
        this.getRecentSpecialty();
      }
    }
  },
  mounted() {
    // app下载二维码
    //this.downApp("android");
    //this.downApp("ios");
  },
  beforeDestroy() {
    if (this.androidCode) {
      this.androidCode = null;
      this.$refs.android.innerHTML = "";
    }
    if (this.iosCode) {
      this.iosCode = null;
      this.$refs.ios.innerHTML = "";
    }
  },
  methods: {
    /**
     * 平台公告
     */
    async getNotices() {
      const { result } = await getNewNotice();
      if (result) {
        this.platformNotices = result;
      }
    },
    /**
     * 最新课程
     */
    async getRecentSpecialty() {
      const { result } = await getNewCourse();
      if (result) {
        this.recentCourses = result;
      }
    },
    // app下载二维码
    downApp(type) {
      this.appType = type;

      // 二维码已经存在就不再重新生成
      if (
        (this.androidCode && type == "android") ||
        (this.iosCode && type == "ios")
      ) {
        return;
      }

      if (type == "android") {
        this.androidCode = this.setQrcode(
          this.$refs.android,
          `${window.location.origin}/#/appDownload`
        );
        // this.androidCode = this.getAndroidUrl();
      } else if (type == "ios") {
        this.iosCode = this.setQrcode(
          this.$refs.ios,
          "https://itunes.apple.com/app/id1551766504"
        );
      }
    },
    setQrcode(dom, url) {
      return new QRCode(dom, {
        width: 95,
        height: 95,
        text: url, // 下载地址
        render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        correctLevel: QRCode.CorrectLevel.H,
        // background: '#f0f',
        // foreground: '#ff0'
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ori-side-banner {
  width: 340px;
  max-width: 340px;
  min-width: 290px;

  .ew-cell {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .cell {
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
      border-radius: 15px;
      overflow: hidden;
      cursor: pointer;

      &.active,
      &:hover {
        @include bgColor("primary");
        color: #fff;
      }
    }

    .ew {
      width: 100%;
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      margin-top: 2px;
      .itemDiv {
        display: flex;
        flex-direction: column;
        align-items: center;
        &:first-child {
          margin-right: 12%;
        }
        p {
          display: flex;
          align-items: center;
          margin-top: 6px;
          i {
            margin-right: 5px;
          }
        }
      }
    }
  }

  /deep/ .empty-img-size100 {
    width: 100px !important;
  }

  .icon {
    display: inline-block;
    vertical-align: middle;
  }

  .content-box {
    margin: 20px;
    margin-left: 0px;
    padding: 0 20px;
    background: #fff;
    // min-height:calc(100vh - 132px);
    overflow: hidden;
  }

  .content {
    border-bottom: 1px solid #dddddd;
    // margin:0 30px;
    margin: 25px 0;
    overflow: hidden;

    &:first-child {
      max-height: 210px;
      padding-bottom: 10px;
    }

    &:nth-child(2) {
      // height: 157px;
      padding-bottom: 20px;
    }

    &:nth-child(3) {
      max-height: 222px;
    }

    &:nth-child(4) {
      max-height: 193px;
    }

    &:last-child {
      border: none;
    }

    .title {
      font-size: 16px;
      font-weight: bold;

      .icon {
        width: 20px;
        height: 24px;
        margin-right: 10px;

        &.icon1 {
          @include themeIcon("17");
          background-size: auto auto !important;
        }
        &.icon2 {
          @include themeIcon("19");
        }
        &.icon3 {
          @include themeIcon("20");
          background-size: auto auto !important;
        }
      }
    }

    .article-list {
      margin-top: 10px;
      .notice-tit {
        display: inline-block;
        width: 100%;
        @extend %ellipse;
      }
      .link {
        display: flex;
        justify-content: space-between;
        color: $textColor;
        margin-top: 6px;
        cursor: pointer;

        // &:hover {
        //   @include fontColor("primary");
        // }

        .tit {
          flex: 1;
          @extend %ellipse;
        }

        .date {
          color: $textGray;
        }
      }
    }

    .img-link {
      display: block;
      margin: 10px 0 0;
      color: $textColor;

      .img {
        width: 100%;
        height: 132px;
      }

      .row {
        display: flex;
        margin-top: 5px;
        .link {
          flex: 1;
          @extend %ellipse;
        }
      }
    }

    .phone-box {
      margin-top: 20px;
      .phone {
        font-size: 21px;
        font-weight: bold;

        .icon {
          width: 24px;
          height: 24px;
          margin-right: 10px;
          @include themeIcon("18");
        }
      }
    }

    .answer-btn {
      width: 100%;
      border-radius: 15px;
      padding-top: 0;
      padding-bottom: 0;
      height: 33px;
      margin-top: 20px;
    }
  }

  /deep/ .el-badge__content {
    line-height: 10px;
  }
}
</style>
